// Search metadata on demand; a changed filter/workspace invalidates old results.
export function createCDRSearch({api,scope,filters,notify,reload}){
 let epoch=0,cursor=null,busy=false,message='',error=false,signature='';
 const state=()=>({cursor,busy,message,error});const publish=()=>notify(state());
 return {state,reset(){epoch++;cursor=null;busy=false;message='';error=false;signature='';publish();},
 async run(more=false){
  if(busy)return;const query=filters(),key=scope()+'|'+JSON.stringify(query);
  if(more&&(!cursor||signature!==key)){this.reset();return;}
  signature=key;const own=++epoch,workspace=scope();busy=true;error=false;message='Searching FreePBX call records… Audio is not being downloaded.';publish();
  try{const result=await api('/history/sync',{...query,...(more?{cursor}:{})});if(own!==epoch||scope()!==workspace)return;
   cursor=result.cursor||null;message=`${result.checked.toLocaleString()} CDR rows checked · ${result.matched.toLocaleString()} authorized call matches. ${cursor?'More records remain; continue this search.':'Search complete.'}`;
   await reload();if(own!==epoch||scope()!==workspace)return;
  }catch(e){if(own!==epoch||scope()!==workspace)return;error=true;message=e.message;cursor=null;}
  finally{if(own===epoch){busy=false;publish();}}
 }};
}
